<template>
  <div class="main-content">
    <div class="conetnt-top">
      <div class="content-top-title">
        <span class="top-title">配置中心</span>
      </div>
      <div class="content-top-form">
        <div>
          成本报表发送邮箱：
          <el-button
            type="primary"
            size="small"
            style="margin-left: 10px"
            @click="onEditEmail"
            >编辑</el-button
          ><span style="margin-left: 10px">{{ emailForm.sendEmails }}</span>
        </div>
      </div>
    </div>
    <div class="content-middle">
      <div style="padding-bottom: 10px">
        芯片映射关系
        <el-button
          type="primary"
          size="small"
          style="margin-left: 10px"
          @click="onAdd"
        >
          新增映射关系</el-button
        >
      </div>
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        ref="tableRef"
        :header-cell-style="{ background: '#F5F7FA', color: '#5C6474' }"
      >
        <el-table-column label="芯片种类ID" prop="id" align="center" />
        <el-table-column label="芯片种类" prop="chipType" align="center" />
        <el-table-column
          label="芯片最大通量(G)"
          prop="chipMaxFlux"
          align="center"
        />
        <el-table-column label="物料编码" prop="materialCode" align="center" />
        <el-table-column label="更新时间" prop="updateTime" align="center" />
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="onEdit(scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="middle-pagination">
        <el-pagination
          :current-page="searchForm.pageNum"
          :page-sizes="searchForm.sizes"
          :page-size="searchForm.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="searchForm.total"
          @current-change="onChangePageNum"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog title="芯片映射关系" :visible.sync="dialogFormVisible">
      <el-form
        :model="dialogform"
        :rules="dialogformRules"
        ref="dialogFormRef"
        label-width="150px"
      >
        <el-form-item label="芯片种类" prop="chipType">
          <el-input
            v-model="dialogform.chipType"
            clearable
            style="width: 60%"
          />
        </el-form-item>
        <el-form-item label="芯片最大通量(G)" prop="chipMaxFlux">
          <el-input-number
            v-model="dialogform.chipMaxFlux"
            clearable
            style="width: 60%"
            :controls="false"
          />
        </el-form-item>
        <el-form-item label="物料编码" prop="materialCode">
          <el-input
            v-model="dialogform.materialCode"
            clearable
            style="width: 60%"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="primary" @click="onSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="成本报表发送邮箱" :visible.sync="emailFormVisible">
      <el-form :model="emailForm" ref="emailFormRef" label-width="20px">
        <el-form-item
          v-for="(item, index) in emailForm.sendEmailArr"
          label=" "
          :key="index"
          :prop="`sendEmailArr.${index}.sendEmail`"
          :rules="[
            { required: true, message: '请输入邮箱地址', trigger: 'blur' },
            {
              type: 'email',
              message: '请输入正确的邮箱地址',
              trigger: ['blur', 'change'],
            },
          ]"
        >
          <el-input v-model="item.sendEmail" style="width: 50%"></el-input
          ><el-button
            @click.prevent="addEmail(item)"
            icon="el-icon-plus"
            style="margin-left: 10px"
            v-show="index === 0"
          ></el-button>
          <el-button
            @click.prevent="removeEmail(index)"
            icon="el-icon-minus"
            v-show="index !== 0"
          ></el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onCancelEmailDialog">取 消</el-button>
        <el-button type="primary" @click="onSubmitEmailDialog">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Big from "big.js";
export default {
  name: "Company",
  data() {
    let validateDate = (rule, value, callback) => {
      console.log("formExtraData", this.formExtraData);
      if (!this.formExtraData.date) {
        callback(new Error("请先选择时段"));
      } else {
        callback();
      }
    };
    return {
      emailFormVisible: false,
      emailForm: {
        sendEmails: "",
        sendEmailArr: [
          {
            sendEmail: "",
          },
        ],
      },
      dialogFormVisible: false,
      dialogformRules: {
        chipMaxFlux: [
          { required: true, message: "请输入芯片最大流量", trigger: "blur" },
        ],
        chipType: [
          { required: true, message: "请输入芯片种类", trigger: "blur" },
        ],
        materialCode: [
          { required: true, message: "请输入物料编码", trigger: "blur" },
        ],
      },
      dialogform: {
        chipMaxFlux: "",
        chipType: "",
        materialCode: "",
      },
      emails: [],
      tableData: [],
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  mounted() {
    this.getList();
    this.getEmails();
  },
  methods: {
    onSubmitEmailDialog() {
      this.$refs["emailFormRef"].validate((valid) => {
        if (valid) {
          const sendEmail = this.emailForm.sendEmailArr
            .map((item) => item.value)
            .join(",");
          this.axios
            .post("batchSaveEmail", this.emailForm.sendEmailArr)
            .then((result) => {
              console.log("result", result);
              if (result.code === 0) {
                this.$message({
                  message: "更新成功",
                  type: "success",
                });
                this.onCancelEmailDialog();
                this.getEmails();
              }
            });
        }
      });
    },
    onCancelEmailDialog() {
      this.emailFormVisible = false;
    },
    addEmail() {
      this.emailForm.sendEmailArr.push({
        sendEmail: "",
      });
    },
    onEditEmail() {
      this.emailFormVisible = true;
    },
    removeEmail(index) {
      this.emailForm.sendEmailArr.splice(index, 1);
    },
    onEdit(row) {
      Object.assign(this.dialogform, row);
      this.dialogFormVisible = true;
    },
    onAdd() {
      this.dialogform = {
        chipMaxFlux: "",
        chipType: "",
        materialCode: "",
      };
      this.dialogFormVisible = true;
    },
    onCancel() {
      this.dialogFormVisible = false;
    },
    onSubmit() {
      this.$refs["dialogFormRef"].validate((valid) => {
        if (valid) {
          if (this.dialogform.id) {
            this.axios
              .post("updateChipConfig", this.dialogform)
              .then((result) => {
                console.log("result", result);
                if (result.code === 0) {
                  this.$message({
                    message: "编辑成功",
                    type: "success",
                  });
                  this.onCancel();
                  this.getList();
                }
              });
          } else {
            this.axios.post("addChipConfig", this.dialogform).then((result) => {
              console.log("result", result);
              if (result.code === 0) {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.onCancel();
                this.getList();
              }
            });
          }
        }
      });
    },
    getTimesNumber(num) {
      let x = new Big(num);
      return x.times(100);
    },
    onChangePageNum(pageNum) {
      this.searchForm.pageNum = pageNum;
      this.getList();
    },
    handleSizeChange(pageSize) {
      this.searchForm.pageSize = pageSize;
      this.getList();
    },
    getEmails() {
      this.axios.get("getAllemail", "").then((result) => {
        this.emailForm.sendEmails = result.data
          .map((item) => item.sendEmail)
          .join(",");
        this.emailForm.sendEmailArr = result.data.map((item) => {
          return {
            sendEmail: item.sendEmail,
          };
        });
      });
    },
    getList() {
      this.axios.get("getChipConfigPage", this.searchForm).then((result) => {
        console.log("result", result);
        this.tableData = result.data.records;
        this.searchForm.total = result.data.total;
      });
    },
  },
};
</script>
<style scoped>
.conetnt-top {
  border-radius: 8px;
  background: #ffffff;
  padding: 12px 24px;
}

.content-top-title {
  padding-bottom: 19px;
}

.top-title {
  font-weight: 500;
  color: #303133;
  font-size: 18px;
  padding-right: 13px;
}

.top-desc {
  color: #606266;
  font-size: 14px;
}

.el-icon-question {
  color: #c0c4cc;
}

.top-form {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.form-item {
  width: 25%;
  padding: 0 12px;
  padding-left: 0;
  margin-bottom: 12px;
}

.form-item-components {
  width: 100%;
}

.form-item-components >>> .require-icon:before {
  content: "*";
  color: #f56c6c;
  margin-left: 10px;
  padding-top: 3px;
  height: 100%;
  display: block;
}

.search-btns {
  width: 100%;
  padding-right: 12px;
  text-align: right;
}

.content-middle {
  padding: 24px;
  margin-top: 15px;
  background: #ffffff;
  box-shadow: 0px 4px 32px 0px rgba(64, 98, 117, 0.12);
  border-radius: 8px;
}

.middle-data {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.middle-data-item {
  width: 24%;
  padding: 24px;
  border-radius: 8px;
}

.middle-data-item:nth-child(1) {
  background: #c6e6f5;
}

.middle-data-item:nth-child(2) {
  background: #c6e6f5;
}

.middle-data-item:nth-child(3) {
  background: #cbedea;
}

.middle-data-item:nth-child(4) {
  background: #f3d9ee;
}
.item-title {
  font-size: 14px;
  font-weight: 400;
  color: #606266;
}
.item-number {
  padding-top: 16px;
  font-size: 28px;
  font-weight: 500;
  color: #303133;
}

.middle-table {
  width: 100%;
}

.middle-pagination {
  padding-top: 10px;
  text-align: right;
}
</style>
